:host {
  display: block;
  --sc-tabs-min-width: 225px;
}

$mobile-size: 750px;

.tab-group {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  border: solid 1px transparent;
  border-radius: 0;
  flex-direction: row;

  @media screen and (min-width: $mobile-size) {
    flex-wrap: nowrap;
  }

  &__tabs {
    display: flex;
    flex-wrap: wrap;
    flex: 0 0 auto;
    flex-direction: column;
    margin-bottom: var(--sc-spacing-xx-large);
  }

  &__nav-container {
    order: 1;
    flex: 1 0 100%;

    @media screen and (min-width: $mobile-size) {
      min-width: var(--sc-tabs-min-width);
      flex: 0 1 auto;
    }
  }

  &__body {
    flex: 1 1 auto;
    order: 2;

    @media screen and (min-width: $mobile-size) {
      padding: 0 var(--sc-spacing-xx-large);
    }
  }

}

::slotted(sc-tab) {
  margin-bottom: var(--sc-spacing-xx-small);
}
